import { Button } from 'components/Button';
import { useDisclose } from 'hooks/utilHooks';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { DiscountCategoriesDefault, IPartnerCreate } from 'types/Partner';

import CloseIcon from '@mui/icons-material/Close';
import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
} from '@mui/material';
import { Box } from '@mui/system';

import { DiscountsInput } from './DiscountsInput';
import DiscountsMessage from './DiscountsMessage';
import { DiscountsRow } from './DiscountsRow';
import { hasMinDiscountPercent } from 'helpers/partner.helpers';

export const DiscountsForm: React.FC = () => {
  const { setValue, getValues, resetField, trigger, control } =
    useFormContext<IPartnerCreate>();
  const { isOpen, onOpen, onClose } = useDisclose();
  const minDiscountDialog = useDisclose();

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'discountsUpdate',
  });

  const handleConfirm = async () => {
    const newDiscounts = getValues().discountsUpdate;

    if (!newDiscounts) {
      return;
    }

    try {
      const isValid = await trigger('discountsUpdate');
      const isValidMinDiscount = hasMinDiscountPercent(newDiscounts);

      if (!isValidMinDiscount) {
        return minDiscountDialog.onOpen();
      }

      if (!isValid) {
        return;
      }

      setValue('discounts', newDiscounts, { shouldValidate: true });
      onClose();
    } catch (reason) {}
  };

  const handleOpen = () => {
    const discountsValue = getValues().discounts;

    if (discountsValue.length) {
      setValue('discountsUpdate', discountsValue);
    } else {
      // @ts-ignore
      append({ categories: DiscountCategoriesDefault, discountValue: '' });
    }

    onOpen();
  };

  const handleClose = () => {
    onClose();
    resetField('discountsUpdate');
  };

  return (
    <>
      <DiscountsInput onClick={handleOpen} />

      <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Descontos</DialogTitle>

        <Divider />

        <DialogContent>
          <DiscountsMessage />

          {fields.map((item, index) => (
            /* @ts-ignore */
            <DiscountsRow
              {...item}
              key={item.id}
              index={index}
              onDeleteClick={() => {
                if (fields.length === 1) {
                  return update(0, {
                    // @ts-ignore
                    categories: DiscountCategoriesDefault,
                    discountValue: '',
                  });
                }
                remove(index);
              }}
            />
          ))}

          <Box flex={1} display="flex" justifyContent="flex-end" mr={7} mt={2}>
            <MuiButton
              color="info"
              onClick={() => {
                append({
                  // @ts-ignore
                  categories: DiscountCategoriesDefault,
                  discountValue: '',
                });
              }}
              type="button"
            >
              + Desconto
            </MuiButton>
          </Box>
        </DialogContent>

        <DialogActions sx={{ m: 4 }}>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleConfirm}>Confirmar</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={minDiscountDialog.isOpen}
        onClose={minDiscountDialog.onClose}
      >
        <DialogTitle>
          Atenção ao desconto
          <IconButton
            aria-label="close"
            onClick={minDiscountDialog.onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pb: 0 }}>
          <DialogContentText>
            O parceiro deve conceder no minimo 20% de desconto em pelo menos uma
            categoria de produto ou serviço.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button variant="text" onClick={minDiscountDialog.onClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DiscountsForm;

